import { SxProps, Typography } from '@mui/material'
import CustomChip from 'src/pages/members/DrillDown/components/CustomChip'
import { getShortOrderId } from 'src/utils/functions'
import PlatformLogo from '../PlatformLogo'

interface OrderIdCompClickableProps {
  platform: string
  orderId: string
  handleClick?: () => void
  textSx?: SxProps
}

const OrderIdCompClickable = ({ platform, orderId, handleClick, textSx }: OrderIdCompClickableProps) => {
  return (
    <CustomChip
      sx={{ justifyContent: 'flex-start' }}
      onClick={handleClick}>
      <PlatformLogo
        shortImg
        platformName={platform}
        height={'18px'}
        width="18px"
        boxSx={{
          flex: 'unset',
          display: 'flex'
        }}
      />
      <Typography
        color="#000"
        fontSize={14}
        fontWeight={600}
        sx={textSx}>
        #{getShortOrderId(platform, orderId)}
      </Typography>
    </CustomChip>
  )
}

export default OrderIdCompClickable
